import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export const useLandlordGuard = () => {
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      try {
        const token = localStorage.getItem('token');
        const currentUser = JSON.parse(localStorage.getItem('user'));

        if (!token || !currentUser) {
          navigate('/login');
          return false;
        }

        if (!currentUser.user.is_landlord) {
          Swal.fire({
            title: 'Access Denied',
            text: 'This area is restricted to landlords only',
            icon: 'error',
            confirmButtonColor: '#1a237e'
          }).then(() => {
            navigate('/');
          });
          return false;
        }

        return true;
      } catch (error) {
        console.error('Auth check error:', error);
        navigate('/login');
        return false;
      }
    };

    setIsAuthorized(checkAuth());
  }, [navigate]);

  return { isAuthorized };
}; 